import {BrowserModule} from '@angular/platform-browser';

import {NgModule, ErrorHandler} from '@angular/core';

import {IonicApp, IonicModule, IonicErrorHandler} from 'ionic-angular';

import {MyApp} from './app.component';

import {HomePage} from '../pages/home/home';

import {StatusBar} from '@ionic-native/status-bar';

import {SplashScreen} from '@ionic-native/splash-screen';

import {LoginPage} from "../pages/login/login";

import {SignupPage} from "../pages/signup/signup";

import {CustomFormsModule} from 'ng2-validation';

import {Storage, IonicStorageModule} from "@ionic/storage";

import {AuthProvider} from "../providers/auth/auth";

import {HttpClientModule} from "@angular/common/http";

import {JWT_OPTIONS, JwtModule} from '@auth0/angular-jwt';

import {TabsPage} from "../pages/tabs/tabs";
import { FCM } from '@ionic-native/fcm';
import {UtentiPage} from "../pages/utenti/utenti";
import {UtenticlientPage} from "../pages/utenticlient/utenticlient";
import {RicercautenticlientPage} from "../pages/ricercautenticlient/ricercautenticlient";
import {EdituserclientPage} from "../pages/edituserclient/edituserclient";
import {RicercautentiPage} from "../pages/ricercautenti/ricercautenti";
import {EdituserPage} from "../pages/edituser/edituser";
import {RicercaordinazionePage} from "../pages/ricercaordinazione/ricercaordinazione";
import {RicercamenuPage} from "../pages/ricercamenu/ricercamenu";


import {OrdinazioniPage} from "../pages/ordinazioni/ordinazioni";
import {ViewordinePage} from "../pages/viewordine/viewordine";
import {ViewordinericercaPage} from "../pages/viewordinericerca/viewordinericerca";

import {ProdottiPage} from "../pages/prodotti/prodotti";
import {ImpostazionePage} from '../pages/impostazione/impostazione';
import {InforistorantePage} from '../pages/inforistorante/inforistorante';
import {AddinforistorantePage} from '../pages/addinforistorante/addinforistorante';
import {EditinfostorePage} from '../pages/editinfostore/editinfostore';

import {CapconsegnaPage} from '../pages/capconsegna/capconsegna';
import {AddcapconsegnaPage} from '../pages/addcapconsegna/addcapconsegna';
import {EditcapconsegnaPage} from '../pages/editcapconsegna/editcapconsegna';

import {OrarioPage} from '../pages/orario/orario';
import {AddorarioPage} from '../pages/addorario/addorario';
import {EditorarioPage} from '../pages/editorario/editorario';
import {CategoriemenuPage} from "../pages/categoriemenu/categoriemenu";
import {AddcategoriamenuPage} from "../pages/addcategoriamenu/addcategoriamenu";
import {AddutentePage} from "../pages/addutente/addutente";

import {CategoriePage} from "../pages/categorie/categorie";
import {ManifestiPage} from "../pages/manifesti/manifesti";
import {AddcategoriaPage} from "../pages/addcategoria/addcategoria";
import {ArticoliPage} from "../pages/articoli/articoli";
import {AddarticoloPage} from "../pages/addarticolo/addarticolo";
import {EditarticoloPage} from "../pages/editarticolo/editarticolo";
import {EditarticolosearchPage} from "../pages/editarticolosearch/editarticolosearch";
import {EditmanifestoPage} from "../pages/editmanifesto/editmanifesto";
import {AddmanifestoPage} from "../pages/addmanifesto/addmanifesto";
import {EditmenusearchPage} from "../pages/editmenusearch/editmenusearch";
import {EditvalutazionePage} from "../pages/editvalutazione/editvalutazione";
import {ValutazionePage} from "../pages/valutazione/valutazione";

import {MenuPage} from "../pages/menu/menu";
import {AddmenuPage} from "../pages/addmenu/addmenu";
import {EditmenuPage} from "../pages/editmenu/editmenu";
import {MenusceltePage} from "../pages/menuscelte/menuscelte";
import {AddsceltaPage} from "../pages/addscelta/addscelta";
import {EditsceltaPage} from "../pages/editscelta/editscelta";
import {AddmenusceltaPage} from "../pages/addmenuscelta/addmenuscelta";
import {EditmenusceltaPage} from "../pages/editmenuscelta/editmenuscelta";
import {SceltePage} from "../pages/scelte/scelte";
import {OttimizzaPage} from "../pages/ottimizza/ottimizza";
import {MessaggioPage} from "../pages/messaggio/messaggio";

import {EditcategoriamenuPage} from "../pages/editcategoriamenu/editcategoriamenu";
import {ResetpasswordPage} from "../pages/resetpassword/resetpassword";
import { CouponPage } from "../pages/coupon/coupon";
import { EditcouponPage } from "../pages/editcoupon/editcoupon";
import { AddcouponPage } from "../pages/addcoupon/addcoupon";
import {EditcategoriaPage} from "../pages/editcategoria/editcategoria";
import {RicercaPage} from "../pages/ricerca/ricerca";
import { SelectSearchableModule } from 'ionic-select-searchable';
import {NotificaPage} from "../pages/notifica/notifica";
import {CommissionePage} from "../pages/commissione/commissione";
import {RicercacouponPage} from "../pages/ricercacoupon/ricercacoupon";
import {ScontiPage} from "../pages/sconti/sconti";
import {EditscontiPage} from "../pages/editsconti/editsconti";

import { FileUploadModule } from 'ng2-file-upload';
import { Camera } from '@ionic-native/camera';//import in app.module.ts
import {File} from "@ionic-native/file";
import { RestApiProvider } from '../providers/rest-api/rest-api';
export function jwtOptionsFactory(storage: Storage) {

  return {

    tokenGetter: () => storage.get('jwt_token'),

    //whitelistedDomains: ['localhost:8040']
   whitelistedDomains: ['itogallarate.etito.it:8020']

    
  }

}



@NgModule({

  declarations: [
    MyApp,

    HomePage,

    LoginPage,

    SignupPage,

    TabsPage,

    OrdinazioniPage,

    ProdottiPage,

    AddorarioPage,

    ImpostazionePage,
    CategoriePage,
    ManifestiPage,
    AddcategoriaPage,
    ArticoliPage,
    UtentiPage,
    EditarticolosearchPage,
    EditmanifestoPage,
    RicercaPage,
    EditarticoloPage,
    EditcategoriaPage,
    InforistorantePage,
    OrarioPage,
    CapconsegnaPage,
    AddinforistorantePage,
    AddcapconsegnaPage,
    ViewordinePage,
    AddarticoloPage,
    //da commentare in produzione

    ValutazionePage,
    EditvalutazionePage,
    ResetpasswordPage,
    EditmenusearchPage,
    AddutentePage,
    EditcategoriamenuPage,
    RicercamenuPage,
    CategoriemenuPage,
    AddcategoriamenuPage,
    AddmanifestoPage,
    EditinfostorePage,
    EditorarioPage,
    EditcapconsegnaPage,
    UtenticlientPage,
    EdituserclientPage,
    RicercautenticlientPage,
    RicercautentiPage,
    EdituserPage,
    RicercaordinazionePage,
    ViewordinericercaPage,
    MenuPage,
    EditmenuPage,
    AddmenuPage,
    MenusceltePage,
    EditsceltaPage,
    AddsceltaPage,
    AddmenusceltaPage,
    EditmenusceltaPage,
    SceltePage,
    NotificaPage,
    OttimizzaPage,
    MessaggioPage,
    CouponPage,
    EditcouponPage,
    AddcouponPage,
    CommissionePage,
    RicercacouponPage,
    ScontiPage,
    EditscontiPage
//fine produzione

  ],

  imports: [

    BrowserModule,
    SelectSearchableModule,
    FileUploadModule,

    HttpClientModule,

    JwtModule.forRoot({

      jwtOptionsProvider: {

        provide: JWT_OPTIONS,

        useFactory: jwtOptionsFactory,

        deps: [Storage]

      }

    }),

    IonicModule.forRoot(MyApp),

    IonicStorageModule.forRoot(),

    CustomFormsModule

  ],

  bootstrap: [IonicApp],

  entryComponents: [

    MyApp,

    HomePage,

    LoginPage,

    SignupPage,
    
    TabsPage,

    OrdinazioniPage,

    ProdottiPage,

    ImpostazionePage,
    CategoriePage,
    ManifestiPage,
    AddcategoriaPage,
    ArticoliPage,
    AddarticoloPage,
    EditarticoloPage,
    EditcategoriaPage,
    RicercaPage,
    EditarticolosearchPage,
    InforistorantePage,
    OrarioPage,
    CapconsegnaPage,
    AddinforistorantePage,
    AddorarioPage,
    AddcapconsegnaPage,
    ViewordinePage,
    UtentiPage,
    EditmanifestoPage,
    AddmanifestoPage,
    EditinfostorePage,
    EditorarioPage,
    EditcapconsegnaPage,
    UtenticlientPage,
    EdituserclientPage,
    RicercautenticlientPage,
    RicercautentiPage,
    EdituserPage,
    RicercaordinazionePage,
    ViewordinericercaPage,
    MenuPage,
    EditmenuPage,
    AddmenuPage,
    MenusceltePage,
    EditsceltaPage,
    AddsceltaPage,
    AddmenusceltaPage,
    EditmenusceltaPage,
    SceltePage,
    CategoriemenuPage,
    AddcategoriamenuPage,
    EditcategoriamenuPage,
    AddutentePage,
    RicercamenuPage,
    EditmenusearchPage,
    ResetpasswordPage,    
    ValutazionePage,
    EditvalutazionePage,
    NotificaPage,
    OttimizzaPage,
    MessaggioPage,   
    CouponPage,
    EditcouponPage,
    AddcouponPage,
    CommissionePage,
    RicercacouponPage,
    ScontiPage,
    EditscontiPage
  ],

  providers: [

    StatusBar,

    SplashScreen,
    FCM,

    {provide: ErrorHandler, useClass: IonicErrorHandler},

    AuthProvider,
    File,
    Camera,
    RestApiProvider //here

  ]

})

export class AppModule {

}


// WEBPACK FOOTER //
// ./src/app/app.module.ts